/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, rate: NonNullable<unknown> }} Endpoint_Other_FromInputs */

const en_endpoint_other_from = /** @type {((inputs: Endpoint_Other_FromInputs) => LocalizedString) & { parts: (inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Other_FromInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`from ${i?.amount} ${i?.rate}`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "from " }, { type: "markup-start", name: "price", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "price", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.rate) }])
			})
		}
	)
);

const zh_hans1_endpoint_other_from = /** @type {((inputs: Endpoint_Other_FromInputs) => LocalizedString) & { parts: (inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Other_FromInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.rate} ${i?.amount} 起`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: String(i?.rate) }, { type: "text", value: " " }, { type: "markup-start", name: "price", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "price", options: {}, attributes: {} }, { type: "text", value: " 起" }])
			})
		}
	)
);

const pt_br2_endpoint_other_from = /** @type {((inputs: Endpoint_Other_FromInputs) => LocalizedString) & { parts: (inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Other_FromInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`a partir de ${i?.amount} ${i?.rate}`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "a partir de " }, { type: "markup-start", name: "price", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "price", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.rate) }])
			})
		}
	)
);

const es_endpoint_other_from = /** @type {((inputs: Endpoint_Other_FromInputs) => LocalizedString) & { parts: (inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Other_FromInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`desde ${i?.amount} ${i?.rate}`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "desde " }, { type: "markup-start", name: "price", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "price", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.rate) }])
			})
		}
	)
);

const fr_endpoint_other_from = /** @type {((inputs: Endpoint_Other_FromInputs) => LocalizedString) & { parts: (inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Other_FromInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`à partir de ${i?.amount} ${i?.rate}`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "à partir de " }, { type: "markup-start", name: "price", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "price", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.rate) }])
			})
		}
	)
);

const de_endpoint_other_from = /** @type {((inputs: Endpoint_Other_FromInputs) => LocalizedString) & { parts: (inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Other_FromInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`ab ${i?.amount} ${i?.rate}`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "ab " }, { type: "markup-start", name: "price", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "price", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.rate) }])
			})
		}
	)
);

const ru_endpoint_other_from = /** @type {((inputs: Endpoint_Other_FromInputs) => LocalizedString) & { parts: (inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Other_FromInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`от ${i?.amount} ${i?.rate}`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "от " }, { type: "markup-start", name: "price", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "price", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.rate) }])
			})
		}
	)
);

const it_endpoint_other_from = /** @type {((inputs: Endpoint_Other_FromInputs) => LocalizedString) & { parts: (inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Other_FromInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`da ${i?.amount} ${i?.rate}`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Other_FromInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "da " }, { type: "markup-start", name: "price", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "price", options: {}, attributes: {} }, { type: "text", value: " " }, { type: "text", value: String(i?.rate) }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "from {amount} {rate}" |
*
* @param {Endpoint_Other_FromInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_other_from = /** @type {((inputs: Endpoint_Other_FromInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs: Endpoint_Other_FromInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Endpoint_Other_FromInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { price: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Other_FromInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_endpoint_other_from(inputs)
			if (locale === "pt-BR") return pt_br2_endpoint_other_from(inputs)
			if (locale === "es") return es_endpoint_other_from(inputs)
			if (locale === "fr") return fr_endpoint_other_from(inputs)
			if (locale === "de") return de_endpoint_other_from(inputs)
			if (locale === "ru") return ru_endpoint_other_from(inputs)
			if (locale === "it") return it_endpoint_other_from(inputs)
			return en_endpoint_other_from(inputs)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Other_FromInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_endpoint_other_from.parts === "function" ? zh_hans1_endpoint_other_from.parts(inputs) : [{ type: "text", value: zh_hans1_endpoint_other_from(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_endpoint_other_from.parts === "function" ? pt_br2_endpoint_other_from.parts(inputs) : [{ type: "text", value: pt_br2_endpoint_other_from(inputs) }]
				if (locale === "es") return typeof es_endpoint_other_from.parts === "function" ? es_endpoint_other_from.parts(inputs) : [{ type: "text", value: es_endpoint_other_from(inputs) }]
				if (locale === "fr") return typeof fr_endpoint_other_from.parts === "function" ? fr_endpoint_other_from.parts(inputs) : [{ type: "text", value: fr_endpoint_other_from(inputs) }]
				if (locale === "de") return typeof de_endpoint_other_from.parts === "function" ? de_endpoint_other_from.parts(inputs) : [{ type: "text", value: de_endpoint_other_from(inputs) }]
				if (locale === "ru") return typeof ru_endpoint_other_from.parts === "function" ? ru_endpoint_other_from.parts(inputs) : [{ type: "text", value: ru_endpoint_other_from(inputs) }]
				if (locale === "it") return typeof it_endpoint_other_from.parts === "function" ? it_endpoint_other_from.parts(inputs) : [{ type: "text", value: it_endpoint_other_from(inputs) }]
				return typeof en_endpoint_other_from.parts === "function" ? en_endpoint_other_from.parts(inputs) : [{ type: "text", value: en_endpoint_other_from(inputs) }]
			})
		}
	)
);